import React, { Component } from "react";
import { Container, Row } from "reactstrap";
import homedata from "../../data/home.json";
import Typed from "react-typed";

class Hero extends Component {
  render() {
    let getData = homedata.herov1;
    let publicUrl = process.env.PUBLIC_URL;

    return (
      <section id="home" className="modern-hero-section">
        <div className="hero-background">
          <div className="gradient-orb orb-1"></div>
          <div className="gradient-orb orb-2"></div>
          <div className="gradient-orb orb-3"></div>
        </div>

        <Container>
          <Row className="full-height align-items-center">
            <div className="hero-content col-lg-6 p-100px-t p-50px-b md-p-10px-b">
              <div className="hero-badge">
                <i className="pe-7s-rocket"></i>
                <span>Transformasi Digital</span>
              </div>

              <h1 className="hero-title">{getData.title}</h1>

              <div className="hero-typed-wrapper">
                <Typed
                  strings={getData.typedText}
                  typeSpeed={40}
                  backSpeed={50}
                  className="typed-text"
                  loop
                />
              </div>

              <p className="hero-description">{getData.desc}</p>

              <div className="hero-cta">
                <a href="#new-products" className="btn-primary-modern">
                  Lihat Produk Kami
                  <i className="fa fa-arrow-right"></i>
                </a>
                <a href="#contact" className="btn-secondary-modern">
                  Hubungi Kami
                </a>
              </div>

              <div className="hero-stats">
                <div className="stat-item">
                  <h3>2022</h3>
                  <p>Didirikan</p>
                </div>
                <div className="stat-item">
                  <h3>10+</h3>
                  <p>Klien</p>
                </div>
                <div className="stat-item">
                  <h3>5+</h3>
                  <p>Produk</p>
                </div>
              </div>
            </div>

            <div className="hero-image col-lg-6 p-100px-t p-50px-b md-p-10px-t">
              <div className="hero-visual">
                <img
                  className="img-fluid floating-image"
                  src={publicUrl + getData.img}
                  alt={getData.title}
                />
              </div>
            </div>
          </Row>
        </Container>

        <style jsx="true">{`
          .modern-hero-section {
            position: relative;
            min-height: 100vh;
            display: flex;
            align-items: center;
            overflow: hidden;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            padding: 100px 0;
          }

          .hero-background {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow: hidden;
            z-index: 0;
          }

          .gradient-orb {
            position: absolute;
            border-radius: 50%;
            filter: blur(80px);
            opacity: 0.3;
            animation: float 20s ease-in-out infinite;
          }

          .orb-1 {
            width: 500px;
            height: 500px;
            background: radial-gradient(circle, #f093fb 0%, transparent 70%);
            top: -250px;
            right: -100px;
            animation-delay: 0s;
          }

          .orb-2 {
            width: 400px;
            height: 400px;
            background: radial-gradient(circle, #4facfe 0%, transparent 70%);
            bottom: -200px;
            left: -100px;
            animation-delay: 5s;
          }

          .orb-3 {
            width: 300px;
            height: 300px;
            background: radial-gradient(circle, #43e97b 0%, transparent 70%);
            top: 50%;
            left: 50%;
            animation-delay: 10s;
          }

          @keyframes float {
            0%,
            100% {
              transform: translate(0, 0) scale(1);
            }
            33% {
              transform: translate(30px, -30px) scale(1.1);
            }
            66% {
              transform: translate(-20px, 20px) scale(0.9);
            }
          }

          .hero-content {
            position: relative;
            z-index: 1;
          }

          .hero-badge {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            padding: 8px 20px;
            border-radius: 50px;
            color: white;
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 25px;
            border: 1px solid rgba(255, 255, 255, 0.3);
          }

          .hero-badge i {
            font-size: 18px;
          }

          .hero-title {
            font-size: 56px;
            font-weight: 800;
            color: white;
            margin-bottom: 20px;
            line-height: 1.2;
            text-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
          }

          .hero-typed-wrapper {
            min-height: 70px;
            margin-bottom: 25px;
          }

          .typed-text {
            font-size: 36px;
            font-weight: 700;
            color: #ffd700;
            text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
          }

          .hero-description {
            font-size: 18px;
            line-height: 1.8;
            color: rgba(255, 255, 255, 0.95);
            margin-bottom: 40px;
            max-width: 90%;
          }

          .hero-cta {
            display: flex;
            gap: 15px;
            margin-bottom: 50px;
            flex-wrap: wrap;
          }

          .btn-primary-modern {
            display: inline-flex;
            align-items: center;
            gap: 10px;
            padding: 16px 36px;
            background: white;
            color: #667eea;
            border-radius: 50px;
            font-weight: 700;
            font-size: 16px;
            text-decoration: none;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease;
          }

          .btn-primary-modern:hover {
            transform: translateY(-3px);
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
            color: #667eea;
            text-decoration: none;
          }

          .btn-primary-modern i {
            transition: transform 0.3s ease;
          }

          .btn-primary-modern:hover i {
            transform: translateX(5px);
          }

          .btn-secondary-modern {
            display: inline-flex;
            align-items: center;
            padding: 16px 36px;
            background: transparent;
            color: white;
            border: 2px solid white;
            border-radius: 50px;
            font-weight: 700;
            font-size: 16px;
            text-decoration: none;
            transition: all 0.3s ease;
          }

          .btn-secondary-modern:hover {
            background: white;
            color: #667eea;
            text-decoration: none;
          }

          .hero-stats {
            display: flex;
            gap: 40px;
            padding-top: 30px;
            border-top: 1px solid rgba(255, 255, 255, 0.2);
          }

          .stat-item h3 {
            font-size: 36px;
            font-weight: 800;
            color: white;
            margin-bottom: 5px;
          }

          .stat-item p {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.8);
            margin: 0;
          }

          .hero-visual {
            position: relative;
            z-index: 1;
          }

          .floating-image {
            animation: floatImage 6s ease-in-out infinite;
            filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.3));
          }

          @keyframes floatImage {
            0%,
            100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-20px);
            }
          }

          @media (max-width: 991px) {
            .modern-hero-section {
              padding: 60px 0;
            }

            .hero-title {
              font-size: 36px;
            }

            .typed-text {
              font-size: 24px;
            }

            .hero-description {
              font-size: 16px;
              max-width: 100%;
            }

            .hero-stats {
              gap: 20px;
            }

            .stat-item h3 {
              font-size: 28px;
            }

            .hero-cta {
              flex-direction: column;
            }

            .btn-primary-modern,
            .btn-secondary-modern {
              width: 100%;
              justify-content: center;
            }
          }
        `}</style>
      </section>
    );
  }
}

export default Hero;
